export default __webpack_public_path__ + "static/media/newsimplan-icon04-en.4d6e08b2.png";